import cheerio from "cheerio";

/**
 * Extracts accessible speech text from HTML content.
 *
 * This function looks for:
 * - Images with alt text
 * - Spans with data-mathml attribute and title text
 */
export function extractSpeechText(containerElement: HTMLElement): string | null;
export function extractSpeechText(htmlContent: string): string | null;
export function extractSpeechText(input: HTMLElement | string): string | null {
  try {
    let containerElement: HTMLElement;

    if (typeof input === "string") {
      if (typeof document === "undefined") {
        const $ = cheerio.load(input);
        return extractTextFromCheerio($);
      }

      const tempDiv = document.createElement("div");
      tempDiv.innerHTML = input;
      containerElement = tempDiv;
    } else {
      containerElement = input;
    }

    const $ = cheerio.load(containerElement.innerHTML);
    return extractTextFromCheerio($);
  } catch (error) {
    console.error("Error extracting speech text:", error);
    return null;
  }
}

function extractTextFromCheerio($: cheerio.Root): string | null {
  // FIXME: temporary workaround to preserve previous highlighting behavior
  // Only use custom parsing if HTML contains img or data-mathml elements
  const hasImgOrMath = $("img").length > 0 || $("[data-mathml]").length > 0;
  if (!hasImgOrMath) {
    return null;
  }

  function extractText(el: any): string | null {
    if (!el) return "";

    if (el.type === "text") {
      return el.data;
    }
    if (el.name === "img") {
      const altText = el.attribs?.alt || "";
      return altText;
    }

    // For spans with data-mathml, prioritize aria-label and don't process children
    if (
      el.name === "span" &&
      el.attribs &&
      el.attribs["data-mathml"] &&
      el.attribs["aria-label"]
    ) {
      const mathText = el.attribs["aria-label"];
      return mathText;
    }

    if (el.attribs && el.attribs["aria-label"]) {
      const ariaText = el.attribs["aria-label"];
      return ariaText;
    }
    if (el.children) {
      return el.children.map(extractText).join(" ");
    }
    return "";
  }

  const root = $("body").length > 0 ? $("body")[0] : $.root()[0];
  const extractedText = extractText(root);
  return extractedText;
}
